import React from 'react';
import { useWatch, Control } from 'react-hook-form';
import { useMobile } from '../../hooks/useMobile';
import RadioGroup from '../BuildingBlocks/Form/RadioGroup';
import Typography from '@material-ui/core/Typography/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  text: {
    fontWeight: 700,
    color: theme.palette.brand.greenDark,
  },
}));

interface ISeasonalProduct {
  setValue?: (id: string, name: string) => void;
  control?: Control;
}
export default function SeasonalProduct({
  setValue,
  control,
}: ISeasonalProduct) {
  const mobile = useMobile();
  const classes = useStyles({ mobile });

  const questions = {
    yes: { id: 'true', text: 'My products are seasonal' },
    no: { id: 'false', text: 'My products are not seasonal' },
  };

  return (
    <>
      <Typography variant={'h6'} className={classes.text}>
        Are most of your products seasonal?
      </Typography>
      <RadioGroup
        groupId={'seasonal'}
        options={Object.values(questions)}
        setValue={setValue}
        useWatch={useWatch}
        control={control}
      />
    </>
  );
}
